import { ExperienceTransferItem } from '../types-store';

export const hasChanges = (item?: ExperienceTransferItem, original?: ExperienceTransferItem): boolean => {

  const compare = item?.id !== original?.id ||
    item?.subscriberGroup?.value !== original?.subscriberGroup?.value ||
    item?.caseType?.value !== original?.caseType?.value ||
    item?.criteria?.value !== original?.criteria?.value ||
    item?.operation?.value !== original?.operation?.value ||
    item?.active !== original?.active;

  if (compare) {
    return true;
  }

  return false;
};
